import { Label as RadixLabel } from "radix-ui";
import type { ComponentPropsWithoutRef, ComponentRef } from "react";
import { tv } from "tailwind-variants";

import { useFormField } from "./use-form-field";

const { Root } = RadixLabel;

export function FormLabel({
  ref,
  className,
  ...props
}: ComponentPropsWithoutRef<typeof Root> & {
  ref?: React.RefObject<ComponentRef<typeof Root> | null>;
}) {
  const { error, formItemId } = useFormField();

  return (
    <Root
      ref={ref}
      htmlFor={formItemId}
      className={tv({
        base: [
          "absolute top-[2px] left-4 origin-left scale-75 cursor-text select-none opacity-50 transition-all",
          "peer-focus:opacity-100 peer-focus-visible:top-[2px] peer-focus-visible:scale-75 peer-focus-visible:font-medium",
          "peer-placeholder-shown:top-4 peer-placeholder-shown:scale-100 peer-placeholder-shown:font-semibold peer-placeholder-shown:text-black/60 peer-placeholder-shown:opacity-100",
          "peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
        ],
        variants: {
          error: {
            true: "text-destructive opacity-100",
          },
        },
      })({ error: Boolean(error), className })}
      {...props}
    />
  );
}
FormLabel.displayName = "FormLabel";
